import { TruffleSvgGradientId } from "../../Utils";
// Theme configuration:
export const MuiSvgIcon = {
    variants: [
        {
            props: { color: "gradient" },
            style: {
                "& svg": {
                    "& path": {
                        fill: `url(#${TruffleSvgGradientId})`
                    }
                }
            }
        }
    ],
    styleOverrides: {
        fontSizeSmall: {
            fontSize: "16px",
            width: "16px",
            height: "16px"
        },
        fontSizeMedium: {
            fontSize: "24px",
            width: "24px",
            height: "24px"
        },
        fontSizeLarge: {
            fontSize: "32px",
            width: "32px",
            height: "32px"
        }
    }
};
//# sourceMappingURL=SvgIcon.js.map